<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Internal customers</h3>
            </div>
        </div>
        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <p class="text-muted">Google sign-in does not store a token. The iOS token is the Apple id.</p>
                    <form class="mb-2" @submit.prevent="applySearch">
                        <div class="form-row align-items-end">
                            <div class="col-md-6">
                                <label for="internal-search">Search by name, email, or phone</label>
                                <input id="internal-search" v-model="term" type="text" class="form-control" placeholder="Name, email, or phone">
                            </div>
                            <div class="col-md-6">
                                <button type="submit" class="btn btn-primary">Search</button>
                                <button v-if="term" type="button" class="btn btn-warning" @click="clearSearch">Clear</button>
                            </div>
                        </div>
                    </form>
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                            <tr>
                                <th>User</th>
                                <th>User id</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Google token</th>
                                <th>iOS token</th>
                                <th>Password</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="customers.data.length === 0">
                                <td colspan="7">No customers.</td>
                            </tr>
                            <tr v-for="customer in customers.data" :key="customer.id">
                                <td>{{ customer.name }}</td>
                                <td>{{ customer.id }}</td>
                                <td>{{ customer.email || '—' }}</td>
                                <td>{{ customer.phone || '—' }}</td>
                                <td>{{ customer.google_token }}</td>
                                <td>{{ customer.ios_token || '—' }}</td>
                                <td>{{ customer.password }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <nav v-if="customers.links.length > 3">
                        <Link
                            v-for="link in customers.links"
                            :key="link.label"
                            :href="link.url || ''"
                            class="btn btn-sm mr-1"
                            :class="link.active ? 'btn-primary' : 'btn-outline-secondary'"
                            v-html="link.label"
                            :disabled="!link.url"
                        />
                    </nav>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2';

export default {
    metaInfo: {title: 'Internal customers'},
    layout: Layout,
    components: {Link},
    props: {
        customers: {type: Object, required: true},
        search: {type: String, default: ''},
    },
    data() {
        return {term: this.search};
    },
    methods: {
        applySearch() {
            this.$inertia.get(route('admin.customers.internal'), {search: this.term}, {preserveState: true});
        },
        clearSearch() {
            this.term = '';
            this.applySearch();
        },
    },
};
</script>
